import type { SoundDesignDto, SoundDesignFacets } from './sound-design.dto.ts'
import { mapFiltersToAlgoliaFilters } from '../../shared/data/mappers/mapFiltersToAlgoliaFilters.ts'
import algoliaClient from '../../shared/data/algolia/algolia-client.ts'
import type { ResponseWithFacetsDto } from '../../shared/data/algolia/algolia-base.dto.ts'
import type { SoundDesignFilters } from '../domain/models/sound-design-filters.ts'
import { algoliaIndex } from '@/logic/configuration.ts'

export const SoundDesignService = {
  getSoundDesigns: async (
    page: number,
    pageSize: number,
    searchTerm: string | undefined,
    filters: SoundDesignFilters
  ): Promise<ResponseWithFacetsDto<SoundDesignDto, SoundDesignFacets>> => {
    const response = await algoliaClient().searchSingleIndex<SoundDesignDto>({
      indexName: algoliaIndex.soundDesign,
      searchParams: {
        query: searchTerm ?? '',
        hitsPerPage: pageSize,
        page,
        filters: mapFiltersToAlgoliaFilters({
          'labels.as.genre.display_values': filters.genres ?? [],
          'labels.as.mood.display_values': filters.moods ?? [],
          'labels.as.instrument.display_values': filters.instruments ?? [],
          'tags.tempo': filters.bpms ?? [],
          'template_generation.type': ['static'],
        }),
        analytics: true,
        distinct: true,
        facets: [
          'labels.as.genre.display_values',
          'labels.as.mood.display_values',
          'labels.as.instrument.display_values',
          'tags.tempo',
        ],
        maxValuesPerFacet: 200,
      },
    })

    return response as ResponseWithFacetsDto<SoundDesignDto, SoundDesignFacets>
  },
}
